import { isRejectedWithValue, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { logout } from '@/features/auth/auth.slice.ts';
import { routes } from '@/router/routes.tsx';
import { notification } from '@/utils/antdAppFeedback.ts';
import { isAppError } from '@/utils/api.tsx';

export const unauthorizedMiddleware: Middleware =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (api: MiddlewareAPI) => (next) => (action: any) => {
    if (
      isRejectedWithValue(action) &&
      action.payload &&
      isAppError(action.payload.data) &&
      action.payload.data.errorCode === 'InvalidAuthToken'
    ) {
      notification.error({
        title: 'Invalid auth token. Logout in 3 seconds.',
      });
      setTimeout(() => {
        api.dispatch(logout());
        window.location.href = routes.logout;
      }, 3000);
    }

    return next(action);
  };
